// cSpell: ignore typesafe
import { action } from 'typesafe-actions';
import { ProcessFlowActionTypes, ProcessFlowStepStoreState, ProcessFlowGotoOptions } from './types';

/* istanbul ignore next */
export const processFlowInit = (
	flowId: string,
	flowUrl: string,
	steps: ProcessFlowStepStoreState[],
	initialStepName?: string
) => action(ProcessFlowActionTypes.INIT, { flowId, flowUrl, steps, initialStepName });
/* istanbul ignore next */
export const processFlowBack = () => action(ProcessFlowActionTypes.BACK);
/* istanbul ignore next */
export const processFlowGoto = (goToStepName: string, gotoFlowUrl?: string, options?: ProcessFlowGotoOptions) =>
	action(ProcessFlowActionTypes.GOTO, { goToStepName, gotoFlowUrl, options });
/* istanbul ignore next */
export const processFlowClear = (flowId: string) => action(ProcessFlowActionTypes.CLEAR, { flowId });
/* istanbul ignore next */
export const processFlowMarkActionDone = () => action(ProcessFlowActionTypes.ACTION_DONE);
